import React from 'react';

export const FEATURES = [
    {
        key: 'imager',
        label: 'Habbo ProImager',
        group: 'Goodies',
        defaultOn: true,
        paths: ['/goodies/imager'],
        note: 'The Staff ProImager and Sulake ProImager are separate tools and stay open.'
    },
    {
        key: 'fontgenerator',
        label: 'Font Generator',
        group: 'Goodies',
        defaultOn: true,
        paths: ['/goodies/fontgenerator']
    },
    {
        key: 'furnicolourer',
        label: 'Furni Colourer',
        group: 'Goodies',
        defaultOn: true,
        paths: ['/goodies/furnicolourer']
    },
    {
        key: 'franklywheel',
        label: 'Frankly Wheel',
        group: 'Goodies',
        defaultOn: true,
        paths: ['/goodies/franklywheel'],
        note: 'The stream overlay at /goodies/franklywheel/overlay keeps working either way, so a live show is never cut off.'
    },
    {
        key: 'appreciate',
        label: 'I Appreciate You',
        group: 'Goodies',
        defaultOn: true,
        paths: ['/goodies/appreciate']
    },
    {
        key: 'askfrank',
        label: 'AskFrank',
        group: 'Goodies',
        defaultOn: false,
        paths: ['/askfrank', '/franklynet'],
        note: 'Also covers the AskFrank hostname. The Housekeeping desks under AskFrank stay open either way.'
    },
    {
        key: 'lobbyburst',
        label: 'Lobby Burst',
        group: 'Games',
        defaultOn: true,
        paths: ['/games/lobbyburst']
    },
    {
        key: 'slimespins',
        label: 'Slimeburger Spin',
        group: 'Games',
        defaultOn: false,
        paths: ['/games/slimeburgerspin'],
        note: 'The wheel has its own open and closed switch on the Slimeburger Spin desk, which is what shows players the closed message.'
    },
    {
        key: 'frankopop',
        label: 'FrankoPop',
        group: 'Community',
        defaultOn: false,
        paths: ['/frankopop'],
        note: 'Covers the shop and My Collection. Awarding FrankoPop from Housekeeping stays open either way.'
    },
    {
        key: 'observer',
        label: 'The Origins Observer',
        group: 'Community',
        defaultOn: true,
        paths: ['/observer'],
        note: 'Issues already published stay readable as articles. This is the Observer page itself.'
    },
    {
        key: 'topposts',
        label: 'Community Posts',
        group: 'Community',
        defaultOn: true,
        paths: ['/members/topposts']
    },
    {
        key: 'frampshack',
        label: "Frank's Framp Shack",
        group: 'Community',
        defaultOn: true,
        paths: ['/members/frampshack'],
        note: 'Framps already spent stay spent. This only closes the shop front.'
    }
];

export const FEATURE_GROUPS = ['Goodies', 'Games', 'Community'];

export const FEATURE_DEFAULTS = FEATURES.reduce((acc, f) => {
    acc[f.key] = f.defaultOn;
    return acc;
}, {});

export const featureByKey = (key) => FEATURES.find(f => f.key === key) || null;

let flags = { ...FEATURE_DEFAULTS };

const listeners = new Set();

const notify = () => {
    listeners.forEach(fn => {
        try { fn(); } catch {}
    });
};

export function getFeatureFlags() {
    return flags;
}

export function setFeatureFlags(incoming) {
    const next = { ...FEATURE_DEFAULTS };
    for (const key of Object.keys(FEATURE_DEFAULTS)) {
        if (incoming?.[key] !== undefined) next[key] = incoming[key] === true;
    }
    flags = next;
    notify();
    return flags;
}

export function useFeatureFlags() {
    const [, bump] = React.useReducer(x => x + 1, 0);

    React.useEffect(() => {
        listeners.add(bump);
        return () => { listeners.delete(bump); };
    }, []);

    return flags;
}
